import React, { useState } from 'react';
import useAddProduct from '../../../hooks/products/useAddProduct';

const AddProducts = () => {
  const [form, setForm] = useState({
    brand: '',
    category: '',
    description: '',
    featured: false,
    images: [null],
    inStock: true,
    name: '',
    price: '',
    quantity: '',
    releaseDate: '',
    sku: '',
    tags: '',
    sale: false,
  });

  const { addProduct, loading, error, success } = useAddProduct();

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  const handleImagesChange = (index, file) => {
    const newImages = [...form.images];
    newImages[index] = file;
    setForm({ ...form, images: newImages });
  };

  const addImageField = () => {
    setForm({ ...form, images: [...form.images, null] });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    await addProduct(form);
  };

  return (
    <div className="max-w-4xl mx-auto p-6 bg-white shadow rounded-md mt-8">
      <h1 className="text-2xl font-semibold mb-4">Add New Product</h1>

      {success && <p className="text-green-600 mb-4">Product added successfully!</p>}
      {error && <p className="text-red-600 mb-4">{error}</p>}

      <form onSubmit={handleSubmit} className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <input type="text" name="name" placeholder="Product Name" className={input} onChange={handleChange} value={form.name} />
        <input type="text" name="brand" placeholder="Brand" className={input} onChange={handleChange} value={form.brand} />
        <input type="text" name="category" placeholder="Category" className={input} onChange={handleChange} value={form.category} />
        <input type="text" name="sku" placeholder="SKU" className={input} onChange={handleChange} value={form.sku} />
        <input type="number" name="price" placeholder="Price" className={input} onChange={handleChange} value={form.price} step="0.01" />
        <input type="number" name="quantity" placeholder="Quantity" className={input} onChange={handleChange} value={form.quantity} />
        <input type="date" name="releaseDate" className={input} onChange={handleChange} value={form.releaseDate} />

        <textarea name="description" placeholder="Description" className={`${input} md:col-span-2`} rows="3" onChange={handleChange} value={form.description} />
        <input type="text" name="tags" placeholder="Tags (comma separated)" className={`${input} md:col-span-2`} onChange={handleChange} value={form.tags} />

        {/* File Upload for Images */}
        <div className="md:col-span-2">
          <label className="block text-sm font-medium text-gray-700 mb-1">Upload Images</label>
          {form.images.map((_, index) => (
            <input
              key={index}
              type="file"
              accept="image/*"
              onChange={(e) => handleImagesChange(index, e.target.files?.[0] || null)}
              className={`${input} mb-2`}
            />
          ))}
          <button
            type="button"
            onClick={addImageField}
            className="text-purple-600 hover:underline text-sm"
          >
            + Add another image
          </button>
        </div>

        {/* Toggles */}
        <div className="flex items-center space-x-2">
          <input type="checkbox" name="featured" checked={form.featured} onChange={handleChange} />
          <label htmlFor="featured" className="text-sm">Featured</label>
        </div>

        <div className="flex items-center space-x-2">
          <input type="checkbox" name="sale" checked={form.sale} onChange={handleChange} />
          <label htmlFor="sale" className="text-sm">On Sale</label>
        </div>

        <div className="flex items-center space-x-2">
          <input type="checkbox" name="inStock" checked={form.inStock} onChange={handleChange} />
          <label htmlFor="inStock" className="text-sm">In Stock</label>
        </div>

        <div className="md:col-span-2 mt-4">
          <button
            type="submit"
            disabled={loading}
            className="bg-purple-600 hover:bg-purple-700 text-white px-6 py-2 rounded-md disabled:opacity-50"
          >
            {loading ? 'Adding...' : 'Add Product'}
          </button>
        </div>
      </form>
    </div>
  );
};

const input = "border border-gray-300 rounded-md p-2 w-full focus:outline-none focus:ring-2 focus:ring-purple-500";

export default AddProducts;
